/* eslint-disable import/newline-after-import */
/* Exports all the actions from a single point.

Allows to import actions like so:

import {action1, action2} from '../actions/'
*/
/* Populated by react-webpack-redux:action */

import {urlWithParams} from '../utils/http';

export function loggedOut() {
  return {
    type: 'LOGGED_OUT'
  };
}

export function receiveUserProfile(json) {
  return {
    type: 'RECEIVE_USER_PROFILE',
    user: json
  };
}

export function receiveTournaments(json) {
  return {
    type: 'RECEIVE_TOURNAMENTS',
    tournaments: json
  };
}

export function receiveTournament(json) {
  return {
    type: 'RECEIVE_TOURNAMENT',
    tournament: json
  };
}

export function fetchTournaments() {
  return dispatch => {
    return fetch('/api/tournaments')
      .then(
        response => response.json()
      ).then(
        json => dispatch(receiveTournaments(json))
      );
  };
}

export function fetchActiveTournaments(params) {
  return dispatch => {
    return fetch(urlWithParams('/api/tournaments/active', params))
      .then(
        response => response.json()
      ).then(
        json => dispatch(receiveTournaments(json))
      );
  };
}

export function fetchActiveTournament(id) {
  return dispatch => {
    return fetch('/api/tournaments/active/' + id.toString())
      .then(
        response => response.json()
      ).then(
        json => dispatch(receiveTournament(json))
      );
  };
}

export function fetchTournament(id) {
  return dispatch => {
    return fetch('/api/tournaments/' + id.toString())
      .then(
        response => response.json()
      ).then(
        json => dispatch(receiveTournament(json))
      );
  };
}



// WEBPACK FOOTER //
// ./actions/index.js